import React from 'react';
import AddItemActions from '../../addItemMenu/AddItemActions';
import * as css from './ActionsBar.css';

interface ActionsBarProps {
    onAddItem: () => void;
    onAddBreak?: () => void;
    disableBreak?: boolean;
}

function ActionsBar({onAddItem, onAddBreak, disableBreak}: ActionsBarProps) {
    return (
        <css.actionsBar>
            <AddItemActions onAddItem={onAddItem} onAddBreak={onAddBreak} disableBreak={disableBreak} />
        </css.actionsBar>
    );
}

export default ActionsBar;
